import { SVGProps } from 'react';

const SvgLock = ({ fill, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 10 12"
    fill={fill || '#A2A9AD'}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M8.179 4h-.572V2.857a2.858 2.858 0 0 0-5.714 0V4h-.571C.693 4 .179 4.514.179 5.143v5.714C.179 11.486.693 12 1.322 12h6.857c.628 0 1.143-.514 1.143-1.143V5.143C9.322 4.514 8.807 4 8.179 4Zm-5.2-1.143c0-.977.794-1.771 1.771-1.771.977 0 1.772.794 1.772 1.771V4H2.979V2.857Z" />
  </svg>
);

export default SvgLock;
